import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import {
  setSelectedStagione,
  setSelectedCampionato,
  setSelectedCategoria,
  setSelectedGirone,
  setSelectedTeam,
  setSelectedNumeroGara,
  setSelectedProvvedimento,
  setSelectedArbitraggio,
  setSelectedPeriodo,
  setSelectedRitardo,
  setSelectedTessera,
  setSelectedArbitro,
  setSelectedSocieta,
} from '../container/selection'

export const useSelectionReset = () => {
  const dispatch = useDispatch()

  const resetSelectedSocieta = useCallback(async () => {
    localStorage.removeItem('selectedSocieta')
    dispatch(setSelectedSocieta())
  }, [dispatch])

  const resetSelectedArbitro = useCallback(async () => {
    localStorage.removeItem('selectedArbitro')
    dispatch(setSelectedArbitro())
  }, [dispatch])

  const resetSelectedTessera = useCallback(async () => {
    localStorage.removeItem('selectedTessera')
    dispatch(setSelectedTessera())
  }, [dispatch])

  const resetSelectedPeriodo = useCallback(async () => {
    localStorage.removeItem('selectedPeriodo')
    dispatch(setSelectedPeriodo())
  }, [dispatch])

  const resetSelectedRitardo = useCallback(async () => {
    localStorage.removeItem('selectedRitardo')
    dispatch(setSelectedRitardo())
  }, [dispatch])

  const resetSelectedArbitraggio = useCallback(async () => {
    localStorage.removeItem('selectedArbitraggio')
    dispatch(setSelectedArbitraggio())
  }, [dispatch])

  const resetSelectedProvvedimento = useCallback(async () => {
    localStorage.removeItem('selectedProvvedimento')
    dispatch(setSelectedProvvedimento())
  }, [dispatch])

  const resetSelectedNumeroGara = useCallback(async () => {
    localStorage.removeItem('selectedNumeroGara')
    dispatch(setSelectedNumeroGara())
  }, [dispatch])

  const resetSelectedTeam = useCallback(async () => {
    localStorage.removeItem('selectedTeam')
    dispatch(setSelectedTeam())
  }, [dispatch])

  const resetSelectedGirone = useCallback(async () => {
    localStorage.removeItem('selectedGirone')
    dispatch(setSelectedGirone())
  }, [dispatch])

  const resetSelectedCategoria = useCallback(async () => {
    localStorage.removeItem('selectedCategoria')
    dispatch(setSelectedCategoria())
    resetSelectedGirone()
  }, [dispatch, resetSelectedGirone])

  const resetSelectedCampionato = useCallback(async () => {
    localStorage.removeItem('selectedCampionato')
    dispatch(setSelectedCampionato())
    resetSelectedCategoria()
  }, [dispatch, resetSelectedCategoria])

  const resetSelectedStagione = useCallback(async () => {
    localStorage.removeItem('selectedStagione')
    dispatch(setSelectedStagione())
  }, [dispatch])

  return {
    resetSelectedSocieta,
    resetSelectedArbitro,
    resetSelectedTessera,
    resetSelectedPeriodo,
    resetSelectedRitardo,
    resetSelectedArbitraggio,
    resetSelectedProvvedimento,
    resetSelectedNumeroGara,
    resetSelectedTeam,
    resetSelectedGirone,
    resetSelectedCategoria,
    resetSelectedCampionato,
    resetSelectedStagione,
  }
}
